export const worksectiondata = [
    {
        icon: "timer",
        title: "Timely Completion",
        text: "We deliver on schedule without ever compromising on quality."
    },
    {
        icon: "plant",
        title: "Eco-Friendly Solutions for Long-Term Value",
        text: "We prioritize sustainability by using eco-friendly materials, low-VOC paints, and membranes to protect both your building and the environment. Our practices adhere to Vancouver’s green building standards, ensuring long-term value and compliance."
    },
    {
        variant: "header",
        subtitle: "DISCOVER WHY",
        title: "We are your Best Choice"
    },
    {
        icon: "roller",
        title: "Minimal Disruption",
        text: "We understand the importance of continuity, which is why we meticulously plan our work to minimize disruption to your operations through proven and time-tested procedures."
    },
    {
        icon: "build",
        title: "Comprehensive Services for High Rise and Commercial Buildings",
        text: "From exterior painting to structural repairs, investigations and window cleaning, HRD Painting and Restoration provides complete property maintenance solutions tailored to your needs."
    },
    {
        icon: "save",
        title: "Safety and Compliance You Can Trust",
        text: "With over two decades of experience, we prioritize safety, efficiency, and full compliance with local regulations, ensuring your building projects are executed flawlessly and responsibly."
    },
];
